module.exports = __webpack_public_path__ + "img/alena.f0837e76.png";